import { render, staticRenderFns } from "./AbscessScarringAndPericarditisTable.vue?vue&type=template&id=64054cc6&scoped=true&"
import script from "./AbscessScarringAndPericarditisTable.vue?vue&type=script&lang=ts&"
export * from "./AbscessScarringAndPericarditisTable.vue?vue&type=script&lang=ts&"
import style0 from "./AbscessScarringAndPericarditisTable.vue?vue&type=style&index=0&id=64054cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64054cc6",
  null
  
)

export default component.exports